import { Card, Typography } from '../ui';
import styles from './Chats.module.css';

// The zero-chats state — Figma 18693:74702 (inside "[Desktop] New Chat / Empty State", 18693:74649):
// a sunken card, Radius/20, 20 padding, holding the stacked-cards mark 24 above its label.
//
// The mark is the SAME bespoke illustration `GroupsEmpty` draws (Figma names both "Textual card + bg",
// 129 × 55.6) — three offset message cards, an avatar dot and two text lines. Only the dot differs:
// here it is `Fill (buttons)/Accent Brand/Default` #A4FF70 where the groups one is pink. Kept as its
// own copy rather than a shared primitive because the two live in unrelated features and the design
// system has not promoted the mark; if a third appears, promote it then.
function StackedChatsMark() {
  return (
    <svg width="129" height="56" viewBox="0 0 129 56" fill="none" aria-hidden className={styles.emptyMark}>
      <rect x="13.5" y="0.5" width="101" height="49" rx="8" className={styles.markBack} />
      <rect x="7" y="8" width="115" height="47" rx="9" className={styles.markMid} />
      <rect x="0.5" y="17.5" width="128" height="38" rx="9" className={styles.markFront} />
      <circle cx="21" cy="37" r="7" className={styles.markDot} />
      <rect x="38" y="33" width="79" height="3" rx="1.5" className={styles.markLine} />
      <rect x="38" y="39" width="63" height="3" rx="1.5" className={styles.markLine} />
    </svg>
  );
}

/** @param label "No chats yet", or the no-results line when a search is active. */
export function ChatsEmpty({ label }: { label: string }) {
  return (
    <Card className={styles.emptyCard}>
      <StackedChatsMark />
      <Typography variant="h4" align="center">{label}</Typography>
    </Card>
  );
}
